import React, { useEffect, useState } from "react";
import { fire } from "../../api/firebaseEnv";
import * as DinamicQueries from "../../api/DinamicsQuery";
import { updateTimeInStore } from "../../api/ListUser";
import { ExclamationDiamond } from "react-bootstrap-icons";
import {
    GoogleMap,
    Marker,
    InfoWindow,
  } from "@react-google-maps/api";

//Elementos DevExpress
import DataGrid, {
  Pager,
  Column,
  Paging,
  FilterRow,
  HeaderFilter,
  ColumnChooser,
  Export,
  Toolbar,
  Item,
  Selection,
} from "devextreme-react/data-grid";
import { Toast } from "devextreme-react/toast";
import { Button } from "devextreme-react/button";
import { CheckBox } from "devextreme-react/check-box";
import ScrollView from "devextreme-react/scroll-view";
import { Popup } from "devextreme-react/popup";
import Accordion from "devextreme-react/accordion";

//Componentes Externos
import CellRenderIconsGrids from "../../components/Grids/icons-grid/icons-grid";
import CellRenderEstatus from "../../components/Grids/estatus-grid-establecimientos/estatus-grid";
import CellRenderMapa from "../../components/Grids/mapa-grid/mapa-grid";
import NewEstablishment from "../../components/popup-create-establishment/newEstablishment";
import EdicionMultiplePopup from "../../components/edicion-multiple-establishment/EdicionMultiplePopup";
import { faCrosshairs } from "@fortawesome/free-solid-svg-icons";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

//CSS
// import './EstablishmentNew.scss';

const ALLOWED_CREATE_ESTABLISHMENT_CEDULAS = new Set(["30235104", "18485795"]);

const EstablishmentNew = () => {
  const [establishmentData, setEstablishmentData] = useState([]);
  const [loadingAPI, setLoadingAPI] = useState(false);
  const [idToEdit, setIdToEdit] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [idToDelete, setIdToDelete] = useState("");
  const [usersWithEstablishment, setUsersWithEstablishment] = useState("");
  const [dataCoordenadas, setdataCoordenadas] = useState("");
  const [showPopupDelete, setShowPopupDelete] = useState(false);
  const [ShowPopupEstablecimientos, setShowPopupEstablecimientos] =
    useState(false);
  const [showClientsPopup, setShowClientsPopup] = useState(false);
  const [clientsData, setClientsData] = useState([]);
  const [clientsAllData, setClientsAllData] = useState([]);
  const [currentStoreId, setCurrentStoreId] = useState(null);
  const [editedClientTimes, setEditedClientTimes] = useState({});
  const [toastConfig, setToastConfig] = React.useState(
    {
      isVisible: false,
      type: "error",
      message:
        "Ya se encuentra un establecimiento registrado con esta dirección",
      displayTime: 4000,
    },
    []
  );

  const [idsEstablecimientos, setidsEstablecimientos] = useState([]);
  const [showEdicionMultiple, setShowEdicionMultiple] = useState(false);
  const [center, setCenter] = useState({ lat: 10.47915, lng: -66.90618 });
  const [map, setMap] = useState(null);
  const [PositionCentral, setPositionCentral] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(false);

  const allowedPageSizes = [30, 50, 100];

  const canCreateEstablishment = (() => {
    try {
      const userData = JSON.parse(localStorage.getItem("userData") || "{}");
      const cedula = String(userData?.cedula ?? "").trim();
      return ALLOWED_CREATE_ESTABLISHMENT_CEDULAS.has(cedula);
    } catch {
      return false;
    }
  })();
  const allowedPageSizesClients = [8, 12, 20];
  const checkedLabel = { "aria-label": "Checked" };

  const getAllEstablishment = () => {
    setLoadingAPI(true);

    DinamicQueries.getData("getAllEstablishment", "EstablecimientosNuevos/")
      .then((resp) => {
        setEstablishmentData(resp.data);
        setLoadingAPI(false);
      })
      .catch((e) => {
        setLoadingAPI(false);
      });
  };

  const openPopup = () => {
    setIdToEdit("0");
    setShowPopup(true);
  };

  const openEditPopup = (data) => {
    setIdToEdit(data.key);
    setShowPopup(true);
  };

  const openClientsPopup = (data) => {
    setShowClientsPopup(true);
    // Llamar al stored procedure para obtener los clientes del establecimiento
    if (data && data.ID) {
      console.log("Datos del establecimiento:", data);
      setCurrentStoreId(data.ID);
      setEditedClientTimes({});
      DinamicQueries.getDataWithParameters("callProcedure", "analytics/", {
        method: "sp_store_for_client",
        params: {
          id_store: data.ID,
        },
      })
        .then((response) => {
          if (response && response.data) {
            setClientsAllData(response.data);
            // Filtrar duplicados: mantener solo el primer registro de cada cliente
            const uniqueClients = [];
            const seenClients = new Set();
            
            response.data.forEach((item) => {
              const cliente = item.CLIENTE || item.cliente;
              if (cliente && !seenClients.has(cliente)) {
                seenClients.add(cliente);
                uniqueClients.push(item);
              }
            });
            
            setClientsData(uniqueClients);
          } else {
            setClientsData([]);
            setClientsAllData([]);
          }
        })
        .catch((error) => {
          console.error("Error al obtener clientes:", error);
          setToastConfig({
            ...toastConfig,
            type: "error",
            message: "Error al cargar los clientes del establecimiento",
            isVisible: true,
          });
          setClientsData([]);
          setClientsAllData([]);
        });
    } else {
      console.warn("No se encontró el ID del establecimiento:", data);
      setClientsData([]);
    }
  };

  const hideClientsPopup = () => {
    setShowClientsPopup(false);
    setClientsData([]);
    setClientsAllData([]);
  };

  const hidePopup = () => {
    setShowPopup(false);
  };

  const successSave = () => {
    setToastConfig({
      ...toastConfig,
      isVisible: true,
      type: "success",
      message: "Establecimiento guardado exitosamente",
    });
    getAllEstablishment();
  };

  const ChangeRevision = (value, info) => {
    fire
      .collection("establecimientos")
      .doc(info.key)
      .update({ revisado: value })
      .then(() => {
        DinamicQueries.getDataWithParameters(
          "updateRevision",
          "EstablecimientosNuevos/",
          { uid: info.key }
        )
          .then(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: true,
              type: "success",
              message: "Establecimiento actualizado exitosamente",
            });
            getAllEstablishment();
          })
          .catch((e) => {
            console.log("🚀 ~ DinamicQueries.getDataWithParameters ~ e:", e);
          });
      })
      .catch((error) => {
        console.log("🚀 ~ fire.collection ~ error:", error);
      });
  };

  const CellRenderVerifica = (data) => {
    return (
      <CheckBox
        defaultValue={data?.data?.revisado}
        elementAttr={checkedLabel}
        onValueChanged={(e) => ChangeRevision(e.value, data.data)}
      />
    );
  };

  const deleteData = (id) => {
    DinamicQueries.getDataWithParameters(
      "getAssignedEstablishment",
      "EstablecimientosNuevos/",
      { id: id }
    )
      .then((resp) => {
        setUsersWithEstablishment(resp.data.data.length);
        setShowPopupDelete(true);
        setIdToDelete(id);
      })
      .catch((error) => {
        console.log(
          "🚀 ~ DinamicQueries.getDataWithParameters ~ error:",
          error
        );
      });
  };

  const deleteFunction = () => {
    DinamicQueries.getDataWithParameters(
      "deleteEstablishment",
      "EstablecimientosNuevos/",
      { id: idToDelete.key }
    )
      .then((resp) => {
        console.log("🚀 ~ DinamicQueries.getDataWithParameters ~ resp:", resp);
        if (resp.data.msg === "establecimiento eliminado") {
          setShowPopupDelete(false);
          getAllEstablishment();
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            type: "success",
            message: "Eliminado exitosamente!",
          });
        }
      })
      .catch((error) => {
        console.log(
          "🚀 ~ DinamicQueries.getDataWithParameters ~ error:",
          error
        );
      });
  };

  useEffect(() => {
    getAllEstablishment();
  }, []);

  const getSelected = () => {
    console.log("Aqui");
    console.log(idsEstablecimientos);
    console.log(establishmentData);
    const datafinal = buscarPorCampo(
      establishmentData,
      "key",
      idsEstablecimientos
    ).filter((x) => x?.coordenadas != undefined && x?.coordenadas != "");
    console.log(datafinal);
    if (datafinal != undefined && datafinal != "" && datafinal?.length != 0){
        const infoNew = datafinal.map(x=>{
            console.log(x)
            // const latlng = x.coordenadas.split(",");
            x.lat = Number(x.coordenadas.lat);
            x.lng = Number(x.coordenadas.lng);
            return x
        })
        console.log(infoNew)
        setdataCoordenadas(infoNew)
    } else {
        setdataCoordenadas([])
    }
    
    navigator.geolocation.getCurrentPosition(function (position) {
    console.log("Latitude is :", position.coords.latitude);
    console.log("Longitude is :", position.coords.longitude);

    setPositionCentral([position.coords.latitude, position.coords.longitude]);
    setShowPopupEstablecimientos(true)
    });

  };

  const handleOptionChange = (e) => {
    if (e.fullName === "selectedRowKeys") {
      setidsEstablecimientos(e.value);
    }
  };

  const buscarPorCampo = (array, key, searchArray) => {
    // Filtra el array buscando objetos que tengan el campo 'key' con un valor que esté en 'searchArray'
    return array.filter((obj) => searchArray.includes(obj[key]));
  };

  const handleLoadMap = (map) => {
    setMap(map);
  };

  return (
    <React.Fragment>
      <style>{`
        .btn-vino.dx-button, .btn-naranja.dx-button { color: #FFFFFF !important; }
        .btn-vino .dx-button-text, .btn-naranja .dx-button-text { color: #FFFFFF !important; }
        .btn-vino { background: #7B1E3C !important; border-color: #7B1E3C !important; }
        .btn-naranja { background: #FF8C00 !important; border-color: #FF8C00 !important; }
        .btn-vino:hover, .btn-naranja:hover { opacity: 0.9; }
        .clients-popup .dx-toolbar-bottom { padding: 16px 20px 22px 20px !important; }
        .clients-popup .dx-toolbar-bottom .dx-toolbar-items-container { align-items: center; }
        .clients-popup .dx-popup-title .dx-toolbar-label { color: #FF8C00 !important; font-weight: 700; }
      `}</style>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
        className="my-4"
      >
        <h6 className={"titleEstablecimiento "}>Establecimientos (Nuevos)</h6>
        <div className="d-flex justify-content-end">
          <Button
            className="btn-agregar"
            onClick={openPopup}
            disabled={loadingAPI || !canCreateEstablishment}
            hint={
              canCreateEstablishment
                ? "Crear nuevo establecimiento"
                : "No tienes permiso para crear establecimientos"
            }
            style={{ width: "270px" }}
          >
            + Crear Establecimiento
          </Button>
        </div>
      </div>

      <DataGrid
        className={"dx-card wide-card"}
        dataSource={establishmentData}
        showBorders={true}
        remoteOperations={true}
        focusedRowEnabled={false}
        keyExpr="key"
        style={{ height: "70vh" }}
        rowAlternationEnabled={true}
        columnAutoWidth={true}
        wordWrapEnabled={true}
        onOptionChanged={(e) => handleOptionChange(e)}
      >
        <ColumnChooser enabled={true} mode="select" />
        <Selection mode="multiple" />
        <FilterRow visible={true} />
        <Paging defaultPageSize={30} />
        <Export enabled={true} />
        <Pager
          showPageSizeSelector={true}as
          showInfo={true}
          allowedPageSizes={allowedPageSizes}
        />
        <HeaderFilter visible={true} />
        <Toolbar>
          <Item location="after">
          <Button
              text="Edición Múltiple"
              onClick={() => setShowEdicionMultiple(true)}
            />
            <Button icon="refresh" onClick={getAllEstablishment} />
            <Button icon="fas fa-map-marker-alt" onClick={getSelected} style={{ color: 'green' }} />

            {/* <FontAwesomeIcon
                            icon={faCrosshairs}
                            className="icon"
                            style={{ color: "green" }}
                            onClick={() => {
                                console.log("Aqui")
                            }}
                        ></FontAwesomeIcon> */}
          </Item>
          <Item name="exportButton" />
          <Item name="columnChooserButton" />
        </Toolbar>

        <Column caption={"ID"} dataField={"ID"} width={140} sortOrder={"asc"} />
        <Column
          dataField={"nombre_establecimiento"}
          caption={"Nombre"}
          dataType="string"
          width={250}
        />

        <Column
          dataField={"razon_social"}
          caption={"Razon Social"}
          dataType="string"
        />

        <Column
          dataField={"nombre_ciudad"}
          caption={"Ciudad"}
          dataType="string"
        />
        <Column
          dataField={"nombre_region"}
          caption={"Región"}
          dataType="string"
        />

        <Column
          dataField={"estatus"}
          caption={"Estatus"}
          dataType="string"
          cellRender={CellRenderEstatus}
        />

        <Column
          dataField={"revisado"}
          caption={"Verificado"}
          dataType="string"
          cellRender={(data) => CellRenderVerifica(data)}
        />

        <Column
          dataField={"coordenadas"}
          caption={"Ver Mapa"}
          dataType="string"
          cellRender={(data) => CellRenderMapa(data)}
        />

        <Column
          width={150}
          caption=""
          allowSorting={false}
          cellRender={(data) => {
            return (
              <div className='d-flex icons_grid'>
                {CellRenderIconsGrids(data, openEditPopup, deleteData, loadingAPI)}
                <FontAwesomeIcon 
                  icon={faUsers} 
                  className="icon" 
                  onClick={() => openClientsPopup(data.data)}
                  title="Ver Clientes"
                />
              </div>
            );
          }}
          name="renderEstab"
        />
      </DataGrid>

      <NewEstablishment
        showpopup={showPopup}
        hidepopup={hidePopup}
        idtoedit={idToEdit}
        successsave={successSave}
      />

      <EdicionMultiplePopup
        visible={showEdicionMultiple}
        onHide={() => setShowEdicionMultiple(false)}
        establishmentData={establishmentData}
        onSaveSuccess={getAllEstablishment}
        toastConfig={toastConfig}
        setToastConfig={setToastConfig}
      />

      <Popup
        width={"50%"}
        height={"50%"}
        visible={showPopupDelete}
        onHiding={() => setShowPopupDelete(false)}
        showTitle={true}
        title="Eliminar Establecimiento"
        showCloseButton={true}
      >
        <ScrollView width="100%" height="100%">
          <div className="form-container text-center">
            <ExclamationDiamond className="warning_icon" />
            <h5>¿Seguro que desea eliminar este registro?</h5>
            <p>
              hay <b>{usersWithEstablishment} Usuarios</b> con este
              establecimiento asignado
            </p>
            <p>Esta acción no puede revertirse</p>
            <div className="d-flex text-center col-md-12 button_popup">
              <Button
                onClick={() => deleteFunction()}
                className="btn btn-outline-primary"
              >
                Sí, eliminar
              </Button>
              <Button
                onClick={() => setShowPopupDelete(false)}
                className="btn btn-outline-secondary"
              >
                Cancelar
              </Button>
            </div>
          </div>
        </ScrollView>
      </Popup>

      <Popup
        width={"50%"}
        height={"50%"}
        visible={ShowPopupEstablecimientos}
        onHiding={() => setShowPopupEstablecimientos(false)}
        showTitle={true}
        title="Establecimientos"
        showCloseButton={true}
        fullScreen={true}
      >
        <ScrollView width="100%" height="100%">
          <div className="form-container text-center">
            {PositionCentral.length > 0 ? (
              <GoogleMap
                center={center}
                zoom={7}
                onLoad={handleLoadMap}
                mapContainerStyle={{ height: "90vh", width: "100%" }}
                // onClick={handleMapClick}
              >
                {dataCoordenadas.length > 0
                  ? dataCoordenadas.map((element, index) => {
                      return (
                        <Marker
                          position={{ lat: element.lat, lng: element.lng }}
                          key={index}
                          onClick={() => setSelectedIndex(index)}
                        >
                          {selectedIndex === index && (
                            <InfoWindow
                              onCloseClick={() => setSelectedIndex(null)}
                            >
                              {/* Contenido del infoWindow */}
                              <div>
                                <p>
                                  <strong>Establecimiento: {element.nombre_establecimiento}</strong>
                                </p>
                                {/* <p>
                                  Formularios cargados:{" "}
                                  {element.nombreFormulario}
                                </p>
                                <p>
                                  Establecimiento: {element.establecimiento}
                                </p>
                                <p> Fecha: {element.fecha_Formulario}</p> */}
                              </div>
                            </InfoWindow>
                          )}
                          {/* <Popup> 
            
            </Popup> */}
                        </Marker>
                      );
                    })
                  : null}
              </GoogleMap>
            ) : null}
          </div>
        </ScrollView>
      </Popup>

      <Toast
        visible={toastConfig.isVisible}
        message={toastConfig.message}
        type={toastConfig.type}
        onHiding={() => setToastConfig({ ...toastConfig, isVisible: false })}
        displayTime={toastConfig.displayTime}
      />

      {/* Popup de Clientes */}
      <Popup
        width={"80%"}
        height={"90%"}
        visible={showClientsPopup}
        onHiding={hideClientsPopup}
        showTitle={true}
        title="Clientes que visitan este establecimiento"
        showCloseButton={true}
        wrapperAttr={{ class: 'clients-popup' }}
        toolbarItems={[
          {
            widget: 'dxButton',
            toolbar: 'bottom',
            location: 'after',
            options: {
              text: 'Guardar cambios',
              stylingMode: 'contained',
              type: 'default',
              elementAttr: {
                class: 'btn-naranja',
                style: 'background:#FF8C00;color:#FFFFFF;border-color:#FF8C00;margin-bottom:16px'
              },
              onClick: async () => {
                try {
                  console.log('[Guardar cambios] editedClientTimes:', editedClientTimes);
                  console.log('[Guardar cambios] clientsData sample:', clientsData && clientsData[0]);
                  console.log('[Guardar cambios] clientsAllData sample:', clientsAllData && clientsAllData[0]);

                  // Obtener ID_ESTABLECIMIENTO del primer registro del SP
                  const firstRecord = (clientsAllData || [])[0];
                  const idStore = firstRecord?.ID_ESTABLECIMIENTO || firstRecord?.id_establecimiento || currentStoreId;
                  
                  if (!idStore) {
                    console.error('[Guardar cambios] No se encontró ID_ESTABLECIMIENTO');
                    setToastConfig({
                      ...toastConfig,
                      isVisible: true,
                      type: 'error',
                      message: 'No se encontró ID del establecimiento',
                    });
                    return;
                  }

                  // Construir arreglo con solo los clientes editados
                  const missingIds = [];
                  const payload = Object.entries(editedClientTimes)
                    .map(([clientKey, minutes]) => {
                      const minutesNum = Number(minutes);
                      if (!Number.isFinite(minutesNum) || minutesNum < 0) return null;

                      // Buscar ID_CLIENTE en clientsAllData por nombre de cliente
                      const clientRecord = (clientsAllData || []).find((rec) => {
                        const name = rec?.CLIENTE || rec?.cliente || '';
                        return String(name) === String(clientKey);
                      });

                      if (!clientRecord) {
                        missingIds.push(clientKey);
                        return null;
                      }

                      // Usar ID_CLIENTE directamente del registro
                      const idClient = clientRecord?.ID_CLIENTE || clientRecord?.id_cliente;
                      
                      if (!idClient || idClient === '' || idClient === null || idClient === undefined) {
                        missingIds.push(clientKey);
                        return null;
                      }

                      const idClientNum = Number(idClient);
                      if (!Number.isFinite(idClientNum)) {
                        missingIds.push(clientKey);
                        return null;
                      }

                      return {
                        id_store: Number(idStore),
                        id_client: idClientNum,
                        minutes: minutesNum,
                      };
                    })
                    .filter(Boolean);

                  if (!payload.length) {
                    if (missingIds.length) {
                      console.warn('No se encontró id_client para:', missingIds);
                    }
                    console.log('[Guardar cambios] payload vacío. editedClientTimes:', editedClientTimes);
                    setToastConfig({
                      ...toastConfig,
                      isVisible: true,
                      type: 'error',
                      message: missingIds.length
                        ? `Faltan id_client para: ${missingIds.join(', ')}`
                        : 'No hay cambios válidos para guardar',
                    });
                    return;
                  }

                  console.log('[Guardar cambios] payload listo para enviar:', payload);
                  // Llamar al endpoint de updateTimeInStore
                  const resp = await updateTimeInStore(payload);

                  if (resp) {
                    // Actualizar clientsData con los nuevos valores guardados
                    const updatedClientsData = clientsData.map((client) => {
                      const nombre = client?.CLIENTE || client?.cliente || '';
                      // Si este cliente fue editado, actualizar su tiempo meta
                      if (Object.prototype.hasOwnProperty.call(editedClientTimes, nombre)) {
                        const newMinutes = editedClientTimes[nombre];
                        return {
                          ...client,
                          'TIEMPO EN ESTABLECIMIENTO': newMinutes !== '' ? String(newMinutes) : '',
                        };
                      }
                      return client;
                    });
                    
                    setClientsData(updatedClientsData);
                    
                    setToastConfig({
                      ...toastConfig,
                      isVisible: true,
                      type: 'success',
                      message: 'Tiempos meta actualizados',
                    });
                    // Limpiar los valores editados después de actualizar clientsData
                    setEditedClientTimes({});
                    // hideClientsPopup(); // si deseas cerrar al guardar, descomenta
                  }
                } catch (error) {
                  console.error('Error al actualizar tiempos meta:', error);
                  setToastConfig({
                    ...toastConfig,
                    isVisible: true,
                    type: 'error',
                    message: 'Error al actualizar tiempos meta',
                  });
                }
              },
            },
          },
        ]}
      >
        <ScrollView width="100%" height="100%">
          <div className="form-container">
            <div style={{ marginBottom: "12px" }}>
              <strong>Nombre del Establecmiento:</strong> {clientsData && clientsData[0]?.ESTABLECIMIENTO ? clientsData[0].ESTABLECIMIENTO : "-"} <span style={{ margin: "0 8px" }}>|</span> <strong>Región:</strong> {clientsData && clientsData[0]?.REGION ? clientsData[0].REGION : "-"}
            </div>

            {Array.isArray(clientsData) && clientsData.length > 0 ? (
              <div>
                <div
                  className="d-flex align-items-center"
                  style={{ fontWeight: 600, padding: "8px 12px", borderBottom: "1px solid #eee", background: "#fafafa", fontSize: "12px" }}
                >
                  <div style={{ flex: 2 }}>Cliente</div>
                  <div style={{ flex: 1 }}>Tiempo meta</div>
                  <div style={{ flex: 1 }}>Tiempo promedio</div>
                  <div style={{ flex: 1 }}>Última visita</div>
                </div>

                <Accordion
                  dataSource={clientsData}
                  itemTitleRender={(item) => {
                    const nombre = item?.CLIENTE || item?.cliente || "Cliente";
                    const tiempoMeta = item?.["TIEMPO EN ESTABLECIMIENTO"] || "";
                    const tiempoPromedio = "";
                    const ultimaVisita = "";
                    return (
                      <div className="d-flex align-items-center" style={{ width: "100%", fontSize: "12px" }}>
                        <div style={{ flex: 2, fontWeight: 600 }}>{nombre}</div>
                        <div style={{ flex: 1 }}>
                          <input
                            type="number"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            min="0"
                            step="1"
                            className="form-control form-control-sm"
                            value={
                              Object.prototype.hasOwnProperty.call(editedClientTimes, nombre)
                                ? editedClientTimes[nombre]
                                : (tiempoMeta ?? '')
                            }
                            placeholder="Tiempo meta"
                            style={{ height: "30px", width: "110px", fontSize: "12px" }}
                            onKeyDown={(e) => {
                              if (["e", "E", "+", "-", ".", ","].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            onChange={(e) => {
                              const val = e.target.value;
                              // Permitir vacío temporal para edición fluida
                              if (val === '') {
                                setEditedClientTimes({ ...editedClientTimes, [nombre]: '' });
                                return;
                              }
                              // Guardar solo enteros no negativos
                              const num = Number(val);
                              if (Number.isFinite(num) && num >= 0) {
                                // Limitar a enteros
                                setEditedClientTimes({ ...editedClientTimes, [nombre]: String(Math.trunc(num)) });
                              }
                            }}
                          />
                        </div>
                        <div style={{ flex: 1 }}>{tiempoPromedio}</div>
                        <div style={{ flex: 1 }}>{ultimaVisita}</div>
                      </div>
                    );
                  }}
                  itemRender={(item) => {
                    const normalize = (s) => (s ? String(s).trim().replace(/\s+/g, ' ') : '');
                    const promoters = (() => {
                      const currentClient = item?.CLIENTE || item?.cliente || "";
                      const collected = [];
                      (clientsAllData || [])
                        .filter((rec) => (rec?.CLIENTE || rec?.cliente || "") === currentClient)
                        .forEach((rec) => {
                          const raw = rec?.USUARIO || rec?.usuario || [];
                          if (Array.isArray(raw)) {
                            collected.push(...raw.map(normalize).filter(Boolean));
                          } else if (typeof raw === "string" && raw.length > 0) {
                            raw
                              .split(",")
                              .map(normalize)
                              .filter(Boolean)
                              .forEach((u) => collected.push(u));
                          }
                        });
                      return Array.from(new Set(collected));
                    })();

                    const days = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];

                    return (
                      <div style={{ padding: "8px 12px" }}>
                        <div className="d-flex" style={{ fontWeight: 600, borderBottom: "1px solid #eee", padding: "8px 0" }}>
                          <div style={{ width: "200px" }}>Promotores</div>
                          {days.map((d) => (
                            <div key={d} style={{ flex: 1, textAlign: "center" }}>{d}</div>
                          ))}
                        </div>

                        {promoters.length > 0 ? (
                          promoters.map((prom) => {
                            const visitDaySet = (() => {
                              const set = new Set();
                              const currentClient = item?.CLIENTE || item?.cliente || "";
                              (clientsAllData || [])
                                .filter((rec) => {
                                  const recUser = normalize(rec?.USUARIO || rec?.usuario || "");
                                  return (rec?.CLIENTE || rec?.cliente || "") === currentClient && recUser === prom;
                                })
                                .forEach((rec) => {
                                  const rawDate = rec?.["DIA VISITA"] || rec?.dia_visita || rec?.diaVisita;
                                  if (rawDate) {
                                    const dt = new Date(rawDate);
                                    const idx = dt.getDay(); // 0=Dom,1=Lun,...
                                    const name = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"][idx];
                                    if (name) set.add(name);
                                  }
                                });
                              return set;
                            })();

                            return (
                              <div key={prom} className="d-flex align-items-center" style={{ borderBottom: "1px solid #f2f2f2", padding: "8px 0" }}>
                                <div style={{ width: "200px" }}>{prom}</div>
                                {days.map((d) => (
                                  <div key={d} style={{ flex: 1, textAlign: "center" }}>
                                    {visitDaySet.has(d) ? (
                                      <span
                                        style={{
                                          display: 'inline-flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          width: 20,
                                          height: 20,
                                          background: '#FF8C00',
                                          color: '#FFFFFF',
                                          borderRadius: 4,
                                        }}
                                      >
                                        <FontAwesomeIcon icon={faCheck} style={{ color: '#FFFFFF', fontSize: 12 }} />
                                      </span>
                                    ) : (
                                      "-"
                                    )}
                                  </div>
                                ))}
                              </div>
                            );
                          })
                        ) : (
                          <div className="text-center" style={{ padding: "12px" }}>Sin promotores</div>
                        )}
                      </div>
                    );
                  }}
                  collapsible={true}
                  multiple={true}
                />
              </div>
            ) : (
              <div className="text-center" style={{ padding: "16px" }}>
                No hay clientes para mostrar.
              </div>
            )}
          </div>
        </ScrollView>
      </Popup>
    </React.Fragment>
  );
};

export default EstablishmentNew;
